import { render, staticRenderFns } from "./ThSortable.vue?vue&type=template&id=4e0afe60&functional=true"
import script from "./ThSortable.vue?vue&type=script&lang=js"
export * from "./ThSortable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports